<template>
	<el-dialog v-dialogDrag title="新增事件" :visible.sync="visible" width="600px" :before-close="close">
		<el-form ref="form" label-width="100px" :model="formParam" :rules="rules" v-loading="formLoading">
			<el-form-item label="事件类型" prop="incidentTypeId">
				<el-cascader v-model="formParam.incidentTypeId" :options="tree" @change="treeChange"
					:show-all-levels="false"
					:props="{checkStrictly: true,label:'typeName',children: 'children',value:'id'}" placeholder="工作类">
				</el-cascader>
			</el-form-item>
			<el-form-item label="事件名称" prop="incidentName">
				<el-input maxlength="100"  v-model="formParam.incidentName" placeholder="请输入事件名称" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="事件描述" prop="incidentDesc">
				<el-input type="textarea" v-model="formParam.incidentDesc" :rows="3" maxlength="200" show-word-limit
					placeholder="建议描述事件在多场景使用时奖扣分值的详情"></el-input>
			</el-form-item>
			<!-- <el-form-item label="A分" prop="aMin">
				<el-input-number v-model="formParam.aMin" controls-position="right" :max="(formParam.aMax?formParam.aMax:'Infinity')*1" ></el-input-number>
				&#12288;- &#12288;
				<el-input-number v-model="formParam.aMax" controls-position="right" :min="(formParam.aMin?formParam.aMin:'-Infinity')*1" ></el-input-number>
			</el-form-item>
			<el-form-item label="B分" prop="bMin">
				<el-input-number v-model="formParam.bMin" controls-position="right" :max="(formParam.bMax?formParam.bMax:'Infinity')*1" ></el-input-number>
				&#12288;- &#12288;
				<el-input-number v-model="formParam.bMax" controls-position="right" :min="(formParam.bMin?formParam.bMin:'-Infinity')*1" ></el-input-number>
			</el-form-item>
			<el-form-item label="产值" prop="outputMin">
				<el-input-number v-model="formParam.outputMin" controls-position="right" :min="0" ></el-input-number>
				&#12288;- &#12288;
				<el-input-number v-model="formParam.outputMax" controls-position="right" :min="(formParam.outputMin?formParam.outputMin:'-Infinity')*1" ></el-input-number>
			</el-form-item> -->
			<el-form-item label="A分:">
				<div class="scoreBox">
					<div class="w120">
						<el-input v-model="formParam.aMin" @input="scoreInp('aMin')" placeholder=""></el-input>
					</div>
					<div class="mlr20">-</div>
					<div class="w120">
						<el-input v-model="formParam.aMax" @input="scoreInp('aMax')" placeholder=""></el-input>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="B分:">
				<div class="scoreBox">
					<div class="w120">
						<el-input v-model="formParam.bMin" @input="scoreInp('bMin')" placeholder=""></el-input>
					</div>
					<div class="mlr20">-</div>
					<div class="w120">
						<el-input v-model="formParam.bMax" @input="scoreInp('bMax')" placeholder=""></el-input>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="产值:">
				<div class="scoreBox">
					<div class="w120">
						<el-input v-model="formParam.outputMin" @input="scoreInp('outputMin')" placeholder="">
						</el-input>
					</div>
					<div class="mlr20">-</div>
					<div class="w120">
						<el-input v-model="formParam.outputMax" @input="scoreInp('outputMax')" placeholder="">
						</el-input>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="事件状态">
				<el-radio v-model="formParam.incidentStatus" :label="1">启用</el-radio>
				<el-radio v-model="formParam.incidentStatus" :label="0">停用</el-radio>
			</el-form-item>
			<div class="title">
				高级设置
			</div>
			<div class="check">
				<p>
					<el-checkbox v-model="isLottery" @change="checkboxChange($event,'isLottery')"
						:disabled="(!formParam.bMin&&!formParam.bMax)||formParam.bMin<0||formParam.bMax<0"
						:true-label="1" :false-label="0">奖票事件</el-checkbox>
					<span>(勾选奖票事件，则该事件审批通过后将相应生成奖票)</span>
				</p>
				<p>
					<el-checkbox v-model="isPiecework" :true-label="1" :false-label="0" @change="checkboxChange($event,'isPiecework')">计件事件</el-checkbox>
					<span>(勾选计件事件，可量化事件数量奖扣)</span>
				</p>
			</div>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="close">取 消</el-button>
			<el-button size="small" type="primary" :loading="btnLoading" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				formParam: {
					incidentName: "",
					incidentStatus: 1,
				},
				showIncidentTypeId: [],
				rules: {
					incidentTypeId: [{
						required: true,
						message: '请选择事件类型',
						trigger: 'change'
					}],
					incidentName: [{
						required: true,
						message: '请输入事件名称',
						trigger: 'blur'
					}],
				},
				formLoading: false,
				btnLoading: false,
				isLottery:0,
				isPiecework:0
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			tree: {
				type: Array,
				default: () => {
					return []
				},
			},
			id: {
				type: Number | String,
				default: null
			}
		},
		computed: {
			visible: {
				get() {
					if (this.id) {
						this.getDetail()
					} else {
						this.formParam = {
							incidentName: "",
							incidentStatus: 1,
							incidentTypeId: this.$parent.pageParam.incidentTypeId
						}
					}
					return this.show;
				},
				set(val) {
					this.$emit("update:show", val);
				},
			},
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			treeChange(e) {
				if (e) {
					this.formParam.incidentTypeId = e[e.length - 1];
				}
			},
			checkboxChange(e,val){
				this.formParam[val]=e
			},
			// 关闭
			close() {
				this.$refs.form.resetFields();
				this.isLottery=0;
				this.isPiecework=0;
				this.$forceUpdate()
				this.$emit('update:show', false)
			},
			//只能输入数字
			scoreInp(val) {
				if (val == 'outputMin' || val == 'outputMax') {
					this.formParam[val] = this.formParam[val].replace(/[^\d]/g, '')
				} else {
					this.formParam[val] = this.formParam[val].replace(/[^\d|-]/g, '')
				}
				if (this.formParam[val] == 0) {
					this.formParam[val] = null
				}
				if ((val == 'bMin' || val == 'bMax') && this.formParam[val] < 0) {
					this.formParam.isLottery = 0
				}
			},
			// 获取详情
			async getDetail() {
				this.formLoading = true;
				let res = await this.$get(`/platform-config/incident/${this.id}`);
				this.formLoading = false;
				if (res && res.code == 0) {
					this.formParam = res.data
				}
			},
			// 点击确认提交
			submit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (this.formParam.bMin < 0 && this.formParam.bMax > 0 || this.formParam.aMin < 0 && this.formParam.aMax > 0 ||
							this.formParam.outputMin < 0 && this.formParam.outputMax > 0) {
							this.$message.warning("分值范围不能从负值到正值!")
							return
						} else if ((Number(this.formParam.bMin) > Number(this.formParam.bMax)) || (Number(this.formParam.aMin) >
								Number(this.formParam.aMax)) || (this.formParam.outputMin > this.formParam.outputMax)) {
							this.$message.warning("最小分数不能大于最大分数!")
							return
						}
						if (this.id) {
							this.update()
						} else {
							this.save()
						}
					}
				});
			},
			// 新增
			async save() {
				this.btnLoading = true;
				let res = await this.$post("/platform-config/incident", this.formParam);
				this.btnLoading = false;
				if (res && res.code == 0) {
					this.$message.success("新增成功！");
					this.$emit('update:show', false)
					this.$parent.getList()
				}
			},
			// 编辑
			async update() {
				this.btnLoading = true;
				let res = await this.$put('/platform-config/incident', this.formParam);
				this.btnLoading = false;
				if (res && res.code == 0) {
					this.$message.success("修改成功！");
					this.$emit('update:show', false)
					this.$parent.getList()
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.smallInput {
		width: 200px;
	}

	.title {
		height: 40px;
		line-height: 40px;
		background-color: rgb(232, 243, 255);
		padding: 0 30px;
	}

	.check {
		padding: 10px 0px 10px 100px;

		>p {
			padding: 10px 0;

			>span {
				font-size: 12px;
				color: #999;
			}
		}
	}

	.scoreBox {
		display: flex;

		.w120 {
			width: 120px;
		}
	}

	.mlr20 {
		display: inline-block;
		margin: 0 20px;
	}
</style>
